import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { cn } from "../../lib/utils";
import { useCart } from "./queries";

/** Link to /cart with how many items the cart holds. */
export function CartLink({ className }: { className?: string }) {
  const count = useCart().data?.item_count ?? 0;
  return (
    <Link
      to="/cart"
      aria-label={`Cart, ${count} item${count === 1 ? "" : "s"}`}
      className={cn(
        "relative flex h-10 items-center gap-2 rounded-lg border border-line bg-elevated px-4 text-sm font-semibold text-ink hover:border-brand hover:text-brand",
        className,
      )}
    >
      <ShoppingCart className="h-4 w-4" /> Cart
      {count > 0 && (
        <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-brand px-1.5 text-xs font-bold tabular-nums text-white">
          {count}
        </span>
      )}
    </Link>
  );
}
